import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskListSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-list-search" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 16.5,
			cy: 16.511,
			r: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 23.25,
			y1: 23.261,
			x2: 20.212,
			y2: 20.223
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 10.511,
			x2: 9.75,
			y2: 10.511
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 14.261,
			x2: 7.5,
			y2: 14.261
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 18.011,
			x2: 7.5,
			y2: 18.011
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.75,23.261H2.25a1.5,1.5,0,0,1-1.5-1.5V6.011a1.5,1.5,0,0,1,1.5-1.5H6a3.75,3.75,0,0,1,7.5,0h3.75a1.5,1.5,0,0,1,1.5,1.5v2.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.75,3.761a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		})
	]
});
export default SvgTaskListSearch;
